<div class="ds-allocation-bar">
  <ng-container *ngFor="let bar of allocationItems; let i = index">
    <div *ngIf="bar.percentage" class="bar" [style.width.%]="bar.percentage * 100" style="--custom-color:{{customColors[i]}}"></div>
  </ng-container>
</div>
